import { FormattedMessage } from 'dibs-react-intl';

export const recognizedDescription = (
    <FormattedMessage
        key="recognizedDescription"
        id="PdpSharedDealerDistinctions.recognizedDescription"
        defaultMessage="These prestigious sellers are industry leaders and represent the highest echelon for item quality and design."
    />
);

export const vettedTooltip = (
    <FormattedMessage
        id="PdpSharedDealerDistinctions.vettedTooltip"
        defaultMessage="Every seller passes strict standards for authenticity and reliability"
    />
);

export const goldTooltip = (
    <FormattedMessage
        id="PdpSharedDealerDistinctions.goldTooltip"
        defaultMessage="Premium sellers maintaining a 4.3+ rating and 24-hour response times"
    />
);

export const platinumTooltip = (
    <FormattedMessage
        id="PdpSharedDealerDistinctions.platinumTooltip"
        defaultMessage="Premium sellers with a 4.7+ rating and 24-hour response times"
    />
);

export const diamondTooltip = (
    <FormattedMessage
        id="PdpSharedDealerDistinctions.diamondTooltip"
        defaultMessage="Premium sellers with a 4.7+ rating and 24-hour response times"
    />
);

export const goldSellerTitle = (
    <FormattedMessage
        key="goldSellerTitle"
        id="PdpSharedDealerDistinctions.goldSellerTitle"
        defaultMessage="Gold"
    />
);

export const goldSellerDescription = (
    <FormattedMessage
        id="PdpSharedDealerDistinctions.goldSellerDescription"
        defaultMessage="These expertly vetted sellers are highly rated and consistently exceed customer expectations."
    />
);

export const platinumSellerTitle = (
    <FormattedMessage
        id="PdpSharedDealerDistinctions.platinumSellerTitle"
        key="platinumSellerTitle"
        defaultMessage="Platinum"
    />
);

export const tieredSellerDescription = (
    <FormattedMessage
        id="PdpSharedDealerDistinctions.tieredSellerDescription"
        defaultMessage="These expertly vetted sellers are 1stDibs' most experienced sellers and are rated highest by our customers."
    />
);

export const diamondSellerTitle = (
    <FormattedMessage
        id="PdpSharedDealerDistinctions.diamondSellerTitle"
        key="diamondSellerTitle"
        defaultMessage="Diamond"
    />
);

export const recognizedSeller = (
    <FormattedMessage
        id="PdpSharedDealerDistinctions.recognizedSeller"
        defaultMessage="Recognized Seller"
    />
);

export const vettedSeller = (
    <FormattedMessage
        id="PdpSharedDealerDistinctions.vettedSeller"
        defaultMessage="Vetted Professional Seller"
    />
);

export const goldSeller = (
    <FormattedMessage id="PdpSharedDealerDistinctions.goldSeller" defaultMessage="Gold Seller" />
);

export const platinumSeller = (
    <FormattedMessage
        id="PdpSharedDealerDistinctions.platinumSeller"
        defaultMessage="Platinum Seller"
    />
);

export const diamondSeller = (
    <FormattedMessage
        id="PdpSharedDealerDistinctions.diamondSeller"
        defaultMessage="Diamond Seller"
    />
);

export const defaultSeller = (
    <FormattedMessage
        id="PdpSharedDealerDistinctions.defaultSeller"
        defaultMessage="1stDibs Seller"
    />
);

export const SELLER_TIER_GOLD = 'gold';
export const SELLER_TIER_PLATINUM = 'platinum';
export const SELLER_TIER_DIAMOND = 'diamond';
export const SELLER_TIER_VETTED = 'vetted';
